import { environment } from '../../environments/environment';

function rollbarProviderConfig(RollbarProvider) {
  if (environment.name !== 'development') {
    // Staging/Production only
    RollbarProvider.init({
      accessToken: environment.rollbarAccessToken,
      captureUncaught: true,
      payload: {
        environment: environment.name,
      },
    });
  }
}

rollbarProviderConfig.$inject = ['RollbarProvider'];

export default rollbarProviderConfig;
